import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EducationType,
  IndustryType,
  InterviewType,
  LoginResponseDataType,
  User,
} from "../interfaces/user";

interface UserState {
  user: User | null;
  profileData: any | null;
  allIndustries: IndustryType[] | Array<any>;
  allEducations: EducationType[] | Array<any>;
  interviews: InterviewType[] | Array<any>;
  isUserProfileComplete: boolean;
}

const initialState: UserState = {
  user: null,
  profileData: null,
  allIndustries: [],
  allEducations: [],
  interviews: [],
  isUserProfileComplete: false,
};

// reducers -> reduce to a specific state -> changes state
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuth: (state, actions: PayloadAction<LoginResponseDataType>) => {
      console.log({ actions });
      if (actions.payload) {
        state.user = actions.payload;
      }
    },
    setProfileData: (state, actions: PayloadAction<any>) => {
      console.log({ actions });
      if (actions.payload) {
        state.profileData = { ...state.profileData, ...actions.payload };
      }
    },

    setIndustries: (state, actions: PayloadAction<any>) => {
      console.log({ actions });
      if (actions.payload) {
        state.allIndustries = actions.payload;
      }
    },
    setEducations: (state, actions: PayloadAction<any>) => {
      console.log({ actions });
      if (actions.payload) {
        state.allEducations = actions.payload;
      }
    },

    setInterviews: (state, actions: PayloadAction<any>) => {
      console.log({ actions });
      if (actions.payload) {
        state.interviews = actions.payload;
      }
    },

    setProfileComplete: (state, actions: PayloadAction<any>) => {
      state.isUserProfileComplete = true;
    },

    reset: () => initialState,
  },
});

// export const getUserToken=(state:RootState)=>state.user.userToken
// export const getUserObj=(state:RootState)=>state.user.user
export const {
  setAuth,
  setProfileData,
  setIndustries,
  setEducations,
  setInterviews,
  setProfileComplete,
  reset,
} = userSlice.actions;

export default userSlice.reducer;
